import React from "react";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import SearchButton from "../../../../components/inputs/searchButton/searchButton";

const SearchStartButton = (): React.JSX.Element => {
  const {
    fetchRatingList,
    fetchAnalytics,
  }: {
    fetchRatingList: () => Promise<void>;
    fetchAnalytics: () => Promise<void>;
  } = React.useContext(RatingOverviewContext);

  const startSearch = () => {
    fetchRatingList();
    fetchAnalytics();
  };

  return (
    <SearchButton disabled={false} isLoading={false} onClick={startSearch} />
  );
};

export default SearchStartButton;
